import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        component: () => import('../layouts/MainLayout.vue'),
        children: [
            {
                path: '/',
                name: 'Inicio',
                component: () => import(/* webpackChunkName: "Inicio"*/'../views/Home.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Login',
                name: 'Login',
                component: () => import(/* webpackChunkName: "Login"*/'../views/Login.vue'),
                meta: { libre: true }
            },
            {
                path: '/AcademicoAlumno/:pIdAlumno/FichaInscripc',
                name: 'AcademicoAlumnoFichaInscripc',
                component: () => import(/* webpackChunkName: "Alumno"*/'../views/Academico/AlumnoFichaInscripc.vue'),
                meta: { libre: true }
            },
            {
                path: '/AcademicoAlumno/:pIdAlumno/FichaInscripc/:pUrl/Url',
                name: 'AcademicoAlumnoFichaInscripc2',
                component: () => import(/* webpackChunkName: "Alumno"*/'../views/Academico/AlumnoFichaInscripc.vue'),
                meta: { libre: true }
            },
            {
                path: '/Admision/:pIdVisitas/Postulante',
                name: 'Postulante',
                component: () => import(/* webpackChunkName: "Postulante"*/'../views/Admision/Postulante.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Alumno',
                name: 'Alumno',
                component: () => import(/* webpackChunkName: "Alumno"*/'../views/Academico/Alumno.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/AlumnoDeuda/:pIdAlumno?',
                name: 'AlumnoDeuda',
                component: () => import(/* webpackChunkName: "AlumnoDeuda"*/'../views/Academico/AlumnoDeuda.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/AlumnoFoto/:pIdAlumno?',
                name: 'AlumnoFoto',
                component: () => import(/* webpackChunkName: "AlumnoFoto"*/'../views/Academico/AlumnoFoto.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/AlumnoItem/:pIdAlumno',
                name: 'AlumnoItem',
                component: () => import(/* webpackChunkName: "AlumnoItem"*/'../views/Academico/AlumnoItem.vue'),
                meta: { ventas: true}
            },
            {
                path: '/AlumnoItem/:pIdAlumno/Accion/:pAccion',
                name: 'AlumnoItemAccion',
                component: () => import(/* webpackChunkName: "AlumnoItemAccion"*/'../views/Academico/AlumnoItem.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/CertificadoModular',
                name: 'CertificadoModular',
                component: () => import(/* webpackChunkName: "CertificadoModular"*/'../views/Titulo/CertificadoModular.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Consejeria',
                name: 'Consejeria',
                component: () => import(/* webpackChunkName: "Consejeria"*/'../views/Academico/Consejeria.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Crm',
                name: 'Crm',
                component: () => import(/* webpackChunkName: "Crm"*/'../views/Crm/Crm.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Itinerario',
                name: 'Itinerario',
                component: () => import(/* webpackChunkName: "Itinerario"*/'../views/DCB/DcbItinerario.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Servicio',
                name: 'Servicio',
                component: () => import(/* webpackChunkName: "Servicio"*/'../views/Servicio.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Lms',
                name: 'Lms',
                component: () => import(/* webpackChunkName: "Lms"*/'../views/Lms/Lms.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/PlanEstudio',
                name: 'PlanEstudio',
                component: () => import(/* webpackChunkName: "PlanEstudio"*/'../views/Academico/PlanEstudio.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Matricula',
                name: 'Matricula',
                component: () => import(/* webpackChunkName: "Matricula"*/'../views/Academico/Matricula.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Ticket',
                name: 'Ticket',
                component: () => import(/* webpackChunkName: "Ticket"*/'../views/Ticket/Ticket.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/TicketItem/:pid?',
                name: 'TicketItem',
                component: () => import(/* webpackChunkName: "TicketItem"*/'../views/Ticket/TicketItem.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/TitulacionModalidad',
                name: 'TitulacionModalidad',
                component: () => import(/* webpackChunkName: "TitulacionModalidad"*/'../views/Titulo/TitulacionModalidad.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Titulo/:pIdTitulacionModalidad?',
                name: 'Titulo',
                component: () => import(/* webpackChunkName: "Titulo"*/'../views/Titulo/Titulo.vue'),
                meta: { administrador: true, ventas: true}
            },
            {
                path: '/Visitante',
                name: 'Visitante',
                component: () => import(/* webpackChunkName: "Visitante"*/'../views/Admision/Visitante.vue'),
                meta: { ventas: true}
            },
            {
                path: '/VisitanteAdd',
                name: 'VisitanteAdd',
                component: () => import(/* webpackChunkName: "VisitanteAdd"*/'../views/Admision/VisitanteAdd.vue'),
                meta: { ventas: true}
            },
            {
                path: '/Minedu',
                name: 'Minedu',
                component: () => import(/* webpackChunkName: "Minedu"*/'../views/Minedu/Minedu.vue'),
                meta: { administrador: true, ventas: true}
            }
        ]
    },
    {
        path: '/AlumnoGeneral/:pIdPersonal',
        name: 'AlumnoGeneral',
        component: () => import(/* webpackChunkName: "AlumnoGeneral"*/'../views/Academico/AlumnoGeneral.vue'),
        meta: { libre: true }
    },
    {
        path: '/AlumnoCVByAlumno/:pIdAlumno',
        name: 'AlumnoCVByAlumno',
        component: () => import(/* webpackChunkName: "AlumnoCVByAlumno"*/'../views/Academico/AlumnoCVByAlumno.vue'),
        meta: { libre: true }
    },
    {
        path: '/CceEvaluacionDocente/:pIdAlumno',
        name: 'CceEvaluacionDocente',
        component: () => import(/* webpackChunkName: "CceEvaluacionDocente"*/'../views/Academico/CceEvaluacionDocente.vue'),
        meta: { libre: true }
    },
    {
        path: '/PersonaCV/:pRol/:pCargo?',
        name: 'PersonaCV',
        component: () => import(/* webpackChunkName: "PersonaCV"*/'../views/PRI/PersonaCV.vue'),
        meta: { libre: true }
    },
    {
        path: '/PersonaCVByDNI/:pDNI',
        name: 'PersonaCVByDNI',
        component: () => import(/* webpackChunkName: "PersonaCVByDNI"*/'../views/PRI/PersonaCVByDNI.vue'),
        meta: { libre: true }
    },
    {
        path: '/CurriculumByDocumentoIdentidad/:pDocumentoIdentidad/:pRol',
        name: 'CurriculumByDocumentoIdentidadView',
        component: () => import(/* webpackChunkName: "CurriculumByDocumentoIdentidad"*/'../views/PRI/CurriculumByDocumentoIdentidad.vue'),
        meta: { libre: true },
        props: true,
    },
    {
        path: '/CapacitacionDocente/:pIdServicio',
        name: 'CapacitacionDocente',
        component: () => import(/* webpackChunkName: "CapacitacionDocente"*/'../views/CCE/CapacitacionDocente.vue'),
        meta: { libre: true }
    },
    {
        path: '/DcbNotaFechaAmpliacion',
        name: 'DcbNotaFechaAmpliacion',
        component: () => import(/* webpackChunkName: "DcbNotaFechaAmpliacion"*/'../views/DCB/DcbNotaFechaAmpliacion.vue'),
        meta: { libre: true }
    },
    {
        path: '/MatriculaByAlumno/:pIdAlumno',
        name: 'MatriculaByAlumno',
        component: () => import(/* webpackChunkName: "MatriculaByAlumno"*/'../views/Academico/MatriculaByAlumno.vue'),
        meta: { libre: true }
    },
    {
        path: '/TestClimaLaboral/:pIdPersonal/:pIDCentroProd',
        name: 'TestClimaLaboral',
        component: () => import(/* webpackChunkName: "TestClimaLaboral"*/'../views/Test/TestClimaLaboral.vue'),
        meta: { libre: true }
    },
    {
        path: '/TestEgresado/:pIdAlumno',
        name: 'TestEgresado',
        component: () => import(/* webpackChunkName: "TestEgresado"*/'../views/Test/TestEgresado.vue'),
        meta: { libre: true }
    },
    {
        path: '/TicketAlumno/:pIdAlumno',
        name: 'TicketAlumno',
        component: () => import(/* webpackChunkName: "TicketAlumno"*/'../views/Ticket/TicketAlumno.vue'),
        meta: { libre: true }
    },
]

const router = new VueRouter({
	routes
})

const DEFAULT_TITLE = 'KHIPU Academico Web';
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.libre)){
        next()
    } else if (store.state.ssUser) {
        next()
    } else {
        next({
            name: 'Login'
        })
    }
})

export default router
